<template>
  <v-app>
    <dashboard-core-app-bar
      v-if="exibeAppBar"
      v-model="expandOnHover"
    />

    <dashboard-core-drawer
      :expand-on-hover.sync="expandOnHover"
      fixed
      clipped
    />

    <dashboard-core-view
      style="background-color: #fff;"
    />

    <!-- style="background-color: #eee;" -->

    <!-- <dashboard-core-settings v-model="expandOnHover" /> -->
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: true,
      exibeAppBar: true,
    }),

    // Método para ocultar a AppBar quando o site é aberto pelo aplicativo movel
    // mounted () {
    //   const plataform = localStorage.getItem('platform')
    //   if (plataform && plataform !== 'unknown') {
    //     this.exibeAppBar = false
    //   }
    // },
  }
</script>
